import { PickList, PickListProps } from "primereact/picklist";
import { useEffect, useState } from "react";

type GenericPickListProps<T> = Omit<
  PickListProps,
  "onChange" | "source" | "target"
> & {
  options: T[];
  onChange: (options: T[]) => void;
  selectedOptionIds: string[];
};

function GenericPickList<T extends { id: string }>({
  onChange,
  ...props
}: GenericPickListProps<T>) {
  const [unselectedOptions, setUnselectedOptions] = useState<T[]>([]);
  const [selectedOptions, setSelectedOptions] = useState<T[]>([]);

  useEffect(() => {
    const newSelectedOptions: T[] = [];
    const newUnselectedOptions: T[] = [];
    props.options.forEach((option) => {
      if (props.selectedOptionIds.includes(option.id)) {
        newSelectedOptions.push(option);
        return;
      }
      newUnselectedOptions.push(option);
    });
    setSelectedOptions(newSelectedOptions);
    setUnselectedOptions(newUnselectedOptions);
  }, [props.selectedOptionIds, props.options]);

  return (
    <PickList
      source={unselectedOptions}
      target={selectedOptions}
      sourceHeader="Alle verfügbaren Notfallkontakte"
      targetHeader="Ausgewählte Notfallkontakte"
      onChange={(event) => {
        setUnselectedOptions(event.source);
        setSelectedOptions(event.target);
        onChange(event.target);
      }}
      {...props}
    />
  );
}
export default GenericPickList;
